import { Mui, MuiIcons } from "@osu/react-ui";
import ExternalLinkIcon from "./ExternalLinkIcon";
import { mergeSxStyles } from "../../styles/util";
import { forwardRef } from "react";

const getHrefProps = (href) => {
  const iconProps = {
    sx: {
      fontSize: 'inherit',
      color: 'inherit',
      verticalAlign: 'super'
    }
  }
  if (href?.startsWith('tel:')) {
    return { href, target: undefined, rel: undefined, iconProps, Icon: MuiIcons.Email };
  }
  if (href?.startsWith('mailto:')) {
    return { href, target: undefined, rel: undefined, iconProps, Icon: MuiIcons.Link  };
  }
  return { href, target: "_blank", rel: "noopener noreferrer", iconProps, Icon: ExternalLinkIcon };
};

const ExternalLink = forwardRef((props, ref) => {
  const { disableIcon: _disableIcon = false, children, sx, ...rest } = props
  const { Icon, iconProps,  ...customProps } = getHrefProps(rest?.href)
  const disableIcon = _disableIcon
  
    return (
      <Mui.Link
        sx={mergeSxStyles(
          {
            fontWeight: 700
          },
          sx
        )}
        ref={ref}
        {...customProps}
        {...rest}
      >
        {children}
        {(!disableIcon && !!Icon) && <Icon {...iconProps} />}
      </Mui.Link>
    );
})

export default ExternalLink;